<template>
  <div class="booking-calendar border rounded w-100" >
    <div class="w-100 d-flex flex-column flex-md-row justify-space-between align-center py-3 border-b">
      <div class="d-flex align-center my-1 my-md-0">
        <v-btn color="primary" :disabled="isToday || loading" @click="setToday()">Vai a oggi</v-btn>
        <v-btn color="primary" icon="mdi-chevron-left" class="mx-2" size="small" @click="prevDay()" :disabled="loading"></v-btn>
        <v-btn color="primary" icon="mdi-chevron-right" size="small" @click="nextDay()" :disabled="loading"></v-btn>
      </div>

      <div class=" my-1 my-md-0">
        <h2 v-if="$vuetify.display.lgAndUp">{{formatDateExtended(date)}}</h2>
        <h3 v-else>{{formatDateExtended(date)}}</h3>

        <div class="d-flex justify-center">
          <v-chip  color="primary" density="compact" class="mx-1" v-if="isToday">OGGI</v-chip>
          <v-chip variant="flat" density="compact" color="error" class="mx-1" v-if="isClosed">CHIUSURA</v-chip>
        </div>
      </div>


      <div class="d-flex align-center my-1 my-md-0">
        <v-menu :close-on-content-click="false">
          <template #activator="{props}">
            <v-btn class="mr-2" variant="outlined" append-icon="mdi-chevron-down" v-bind="props" :disabled="loading">{{formatDate(date)}}</v-btn>
          </template>
          <v-date-picker v-model="dateJs"></v-date-picker>
        </v-menu>

        <v-btn v-if="isEditor" color="primary" append-icon="mdi-plus" @click="openBookingDialog()" :disabled="loading || isClosed">Aggiungi</v-btn>
      </div>




    </div>
    <v-progress-linear indeterminate color="primary" v-if="loading" class="w-100"></v-progress-linear>
    <v-table density="compact" striped="even" >
      <tbody>
      <tr v-if="!hours.length || isClosed">
        <td colspan="2" class="text-center font-italic py-4">
          Non ci sono ore di lavoro per questa giornata
        </td>
      </tr>
      <tr v-if="!isClosed" v-for="hour in hours" :key="hour.time._id" :id="isCurrentHour(hour.time) ? 'current-hour' : undefined" :class="isCurrentHour(hour.time) ? 'bg-orange-lighten-4' : ''">
        <td style="width: 100px" class="border-e">
          <p class="text-center"><strong>Ore {{hour.time.time}}</strong></p>
          <p class="text-error font-weight-bold text-center">{{hour.events.length}} utenti</p>
          <p class="text-grey-darken-2 text-center" v-if="hour.time.name">{{hour.time.name}}</p>
          <p class="text-center"><v-btn  class="mb-2" :icon="expanded[hour.time._id!] ? 'mdi-arrow-collapse-all' : 'mdi-arrow-expand-all'" size="small" variant="outlined" :color="expanded[hour.time._id!] ? 'primary':'black'" @click="expanded[hour.time._id!] = !expanded[hour.time._id!]"></v-btn></p>
        </td>
        <td class="px-0 px-lg-4">
          <div :class="`d-flex ${expanded[hour.time._id!] ? 'flex-wrap' : ''} w-100`">
            <v-card v-for="evt in hour.events" :key="evt._id" tile class="ma-0 ma-md-1" style="border-radius: 0 !important;"
                    variant="outlined" :class="evt.genre === 'M' ? 'bg-blue-lighten-5' : 'bg-pink-lighten-5'" @click="selectedEvent = evt; eventDialog = true">
              <v-card-text :class="expanded[hour.time._id!] ? 'pa-2' : 'pa-1'">
                <h4 v-if="$vuetify.display.lgAndUp">{{evt.title}} <v-tooltip><template #activator="{props}">
                  <v-icon v-if="evt.noUserSeatError" v-bind="props" color="error" icon="mdi-alert-circle"></v-icon></template><p>Pacchetto sedute della prenotazione inesistente!</p></v-tooltip></h4>
                <h5 v-else>{{evt.titleSmall}}
                  <v-tooltip><template #activator="{props}"><v-icon v-if="evt.noUserSeatError" v-bind="props" color="error" icon="mdi-alert-circle"></v-icon></template><p>Pacchetto sedute della prenotazione inesistente!</p></v-tooltip></h5>
                <div class="d-flex flex-wrap" v-if="expanded[hour.time._id!]">
                  <v-chip v-if="evt.noCard" variant="flat" size="small" density="compact" color="error" class="mr-1 mb-1">senza tessera</v-chip>
                  <v-chip v-if="evt.certStatus === 'none'" variant="flat" size="small" density="compact" color="error" class="mr-1 mb-1">senza certificato</v-chip>
                  <v-chip v-if="evt.certStatus === 'expired'" variant="flat" size="small" density="compact" color="error" class="mr-1 mb-1">certificato scaduto</v-chip>
                </div>
                <div class="d-flex flex-wrap" v-else-if="$vuetify.display.lgAndUp">
                  <v-chip v-if="evt.noCard" variant="flat" size="small" density="compact" color="error" class="mr-1 mb-1">no tess.</v-chip>
                  <v-chip v-if="evt.certStatus === 'none'" variant="flat" size="small" density="compact" color="error" class="mr-1 mb-1">no cert.</v-chip>
                  <v-chip v-if="evt.certStatus === 'expired'" variant="flat" size="small" density="compact" color="error" class="mr-1 mb-1">cert. scad.</v-chip>
                </div>
                <div class="d-flex flex-wrap" v-else>
                  <v-icon v-if="evt.noCard || evt.certStatus === 'none' || evt.certStatus === 'expired'" icon="mdi-alert-circle" color="error"></v-icon>
                </div>
                <p v-if="expanded[hour.time._id!]">ore <strong>{{evt.when.toFormat("HH:mm")}}</strong></p>
                <ul v-if="expanded[hour.time._id!] && evt.item.prefs && evt.item.prefs.length" class="pl-4" >
                  <li v-for="pref in evt.item.prefs" :key="`${evt._id}-${pref._id}`" class="text-info font-weight-bold">{{pref.name}}</li>
                </ul>
              </v-card-text>
            </v-card>
          </div>
        </td>
      </tr>
      </tbody>
    </v-table>

    <v-dialog v-model="addBookingDialog" max-width="800">
      <v-card>
        <v-form ref="form" @submit.prevent="addBooking()" >
          <v-card-title>
            <h3>Aggiungi prenotazione</h3>
          </v-card-title>
          <v-card-text>
            <v-row class="mt-2">
              <v-col cols="12" lg="6">
                <v-autocomplete label="Utente" :items="userOptions" v-model="newItem.user_id"
                                :rules="[rules.required]">


                  <template v-slot:selection="{item}">
                    <div>
                      <h4 class="mb-0" style="line-height: 1.1" >{{item.title}}</h4>
                      <p class="text-caption text-grey-darken-3" style="line-height: 1">{{item.fiscal_code}}</p>
                    </div>


                  </template>

                  <template v-slot:item="{props, item}">
                    <v-list-item v-bind="props" :subtitle="item.fiscal_code"></v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12"lg="6">
                <v-select :items="validUserSeatsOptions" label="Pacchetto abbonamento" v-model="newItem.user_seat_id" style="max-width: 600px">
                  <template #item="{ item, props}">
                    <v-list-item  v-bind="props">
                      <template #title>
                        <div >

                          <h5 v-if="getProductName(item.data.product_id!)" class="no-select">Pacchetto "{{getProductName(item.data.product_id!)}}" con accesso a sedute di tipo:</h5>
                          <h5 v-else class="no-select">Pacchetto con accesso a sedute di tipo:</h5>
                          <v-chip-group>
                            <div :style="`background-color: ${getSeatsTypeColor(st)}`" class="rounded-pill text-white font-weight-bold text-uppercase text-caption px-2 mr-1 " v-for="(st, j) in item.data.seats_types"
                                 :key="`valid_listus_${item.data._id}_st_${j}`">{{getSeatsTypeLabel(st)}}</div>
                          </v-chip-group>
                          <p v-if="item.data.expiration" class="warning--text caption mb-0">Scadenza {{formatDate(item.data.expiration)}}.</p>
                          <p class="warning--text no-select caption mb-0" v-if="item.data.consumable && !item.data.expiration">Durata di {{item.data.duration}} giorni a partire dalla prima prenotazione.</p>
                          <p class="text-success no-select caption mb-0" v-if="item.data.consumable">{{item.data.available - item.data.used}} sedute disponibili.</p>

                        </div>
                      </template>
                    </v-list-item>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" lg="6">
                <v-text-field label="Data" type="date" v-model="bookingDate" clearable @update:model-value="newItem.calendar_hour_id = ''" :rules="[rules.required]" :hint="bookingDateFormat" persistent-hint />
              </v-col>

              <v-col cols="12" lg="6">
                <v-select label="Ora" :items="bookingHoursOptions" v-model="newItem.calendar_hour_id" :disabled="!bookingDate"
                          :rules="[rules.required]" @update:model-value="updateBookingDate()"/>
              </v-col>
              <v-col cols="12" v-if="currentPrefs.length">
                <h4>Preferenze sulla lezione</h4>
                <div class="d-flex flex-wrap">
                  <v-checkbox class="mr-3" hide-details density="compact" color="primary"
                              v-for="p in currentPrefs" :key="p._id" v-model="newItem.prefs_ids" :label="p.name" :value="p._id" c></v-checkbox>
                </div>

              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="addBookingDialog = false">Chiudi</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" variant="elevated" type="submit">Inserisci prenotazione</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="eventDialog" max-width="800">
      <v-card>
        <v-card-text v-if="selectedEvent">
          <h2 class="mb-3">Dettaglio prenotazione</h2>
          <h3 class="mb-3">Utente: <span class="text-info">{{selectedEvent.title}}</span></h3>
          <h4 class="mb-2">Scadenza certificato: <v-chip density="compact" variant="flat" :color="certStatusColor(selectedEvent.certStatus)">{{selectedEvent.certExpire}}</v-chip> </h4>
          <h4 class="mb-2">Scadenza tessera MSP: <v-chip density="compact" variant="flat" :color="selectedEvent.noCard ? 'error':'success'">{{selectedEvent.cardExpire}}</v-chip> </h4>
          <h4 v-if="selectedEvent.item.prefs && selectedEvent.item.prefs.length">Preferenza per la seduta:</h4>
          <ul v-if="selectedEvent.item.prefs && selectedEvent.item.prefs.length">
            <li v-for="pref in selectedEvent.item.prefs" :key="`sel_evt_${pref._id}`">{{pref.name}}</li>
          </ul>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="eventDialog = false;">Chiudi</v-btn>
          <v-spacer></v-spacer>
          <v-btn v-if="selectedEvent && isEditor" color="error" variant="elevated" @click="removeBooking(selectedEvent)" :disabled="loading" :loading="loading">Elimina prenotazione</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import {
  computed, defineComponent, inject, nextTick,
  onBeforeUnmount, onMounted, type PropType, ref, useTemplateRef, watch
} from 'vue'
import {DateTime} from "luxon";
import utils from "@/utils";
import api from "@/api";
import {type Booking, type BookingDisplay, type BookingEvent, type CalendarHour, SeatsType} from "@/models.ts";
import {Messages, Msg} from "@/plugins/messages.ts";
import type {Globals} from "@/plugins/globals.ts";
import type {VForm} from "vuetify/components";
import rules from "@/utils/rules.ts";
import {seatsTypesOptions} from "@/consts.ts";
import type {Auth} from "@/plugins/auth.ts";

export default defineComponent({
  name: "BookingCalendar",
  props : {
    seatsType : {
      type : String as PropType<SeatsType>,
      default : SeatsType.exp
    },
    calendarHours : {
      type : Array as PropType<CalendarHour[]>,
      default : []
    }
  },
  setup(props, ctx) {
    const auth = inject('auth') as Auth
    const globals = inject('globals') as Globals
    const messages = inject('messages') as Messages

    const loading = ref(false)
    const addBookingDialog = ref(false)
    const date = ref<DateTime>(DateTime.now())
    const eventDialog = ref(false)
    const selectedEvent = ref<BookingEvent|undefined>()
    const holidays = ref<Record<string, boolean>>({})
    const expanded = ref<Record<string, boolean>>({})

    const form = useTemplateRef<typeof VForm>('form')

    const bookings = ref<BookingDisplay[]>([])

    const newItem = ref<Booking>({
      calendar_hour_id: "", date: "", prefs_ids: [], type: SeatsType.exp, user_id: "", user_seat_id: ""
    })
    const bookingDate = ref<string>('')

    const loadBookingData = async () => {
      loading.value = true;

      const res = await api.list<BookingDisplay>('booking', { from : date.value.toISODate(), to : date.value.toISODate() }, 0, 0, '+date')
      loading.value = false;
      if(!res.success) {
        messages.error(res.message ?? Msg.serverError)
        return
      }
      bookings.value = res.data?.filter(i => i.calendar_hour.type === props.seatsType) ?? []
    }


    const events = computed<BookingEvent[]>(()=>{
      return bookings.value.map(item => {
        let date = utils.toDateTime(item.date)
        let evt:BookingEvent = {
          _id : item._id!,
          title : `${item.user.name} ${item.user.surname}`,
          titleSmall : `${item.user.name[0]}. ${item.user.surname}`,
          when : date,
          noCard : false,
          certStatus : 'valid',
          certExpire : 'mai avuto',
          cardExpire : '-',
          genre : 'M',
          noUserSeatError : !item.user_seat,
          item
        }

        const fiscalDt = utils.toInt(`${item.user.fiscal_code[9]}${item.user.fiscal_code[10]}`, 0)
        if(fiscalDt > 40) {
          evt.genre = 'F'
        }


        if(!item.user.medical_cert) {
          evt.certStatus = "none"
        }
        if(item.user.medical_cert_expiration) {
          const dt = DateTime.fromISO(item.user.medical_cert_expiration)
          evt.certExpire = dt.toFormat("dd/MM/yyyy")
          if(dt < DateTime.now().plus({hour : 96})) {
            evt.certStatus = "expiring"
          }
          if(dt < DateTime.now()) {
            evt.certStatus = "expired"
          }
        }
        let coni = globals.cards.value.find(c => {
          if(c.user_id !== item.user_id) return false
          const dt = DateTime.fromISO(c.expiration)
          return dt > DateTime.now()
        })
        if(!coni) {
          evt.noCard = true
        } else {
          const dt = DateTime.fromISO(coni.expiration)!
          evt.cardExpire = dt.toFormat("dd/MM/yyyy")
        }
        return evt
      })
    })

    const times = computed(()=>{

      //console.log("times", date.value.weekday)

      return props.calendarHours.filter(i => i.day === date.value.weekday)
    })


    const hours = computed(()=>{
      return times.value.map(time => {
        return {
          time,
          events : events.value.filter(e => e.item.calendar_hour_id === time._id)
        }
      })
    })

    const checkIfHoliday = async () => {
      const value = date.value.toISODate()!
      if(holidays.value[value] !== undefined) return
      const res = await api.get<boolean>('holidays', `check/${value}`)
      if(res.data !== undefined) holidays.value[value] = res.data
    }

    const isToday = computed(()=>{
      return date.value.toISODate() === DateTime.now().toISODate()
    })


    const validUserSeats = computed(()=>{
      const today = DateTime.now().endOf('day')
      const filter = globals.userseats.value.filter(s => {
        if(s.user_id !== newItem.value.user_id) return false
        if(!s.seats_types || !s.seats_types.includes(props.seatsType)) return false
        if(s.expiration) {
          let exp = DateTime.fromISO(s.expiration)
          if(exp < today) {
            return false;
          }
        }
        return !(s.consumable && s.available <= s.used);

      })
      return filter
    })

    const getSeatsTypeLabel = ( st:SeatsType ) => {
      const opt = seatsTypesOptions.find(i => i.value === st)
      return opt ? opt.title : st;
    }

    const openEvent = (id:string) => {
      if(loading.value) {
        setTimeout(()=>{
          openEvent(id)
        }, 250)
        return;
      }
      const evt = events.value.find(e => e._id === id)
      if(evt) {
        selectedEvent.value = evt;
        eventDialog.value = true;
      }
    }


    ctx.expose({
      setDate(dt:DateTime) {
        date.value = dt;
      },
      openEvent,
    })



    let wh:any;
    onMounted(async ()=>{
      wh = watch(date, async ()=>{
        await loadBookingData()
        await checkIfHoliday()
      })

      await Promise.all([
        globals.refresh('bookingprefs'),
        globals.refresh('cards'),
        globals.refresh('users'),
        globals.refresh('userseats'),
        globals.refresh('products'),
      ])
      await loadBookingData()
      await checkIfHoliday()

      await nextTick()
      const currentHourRow = document.getElementById('current-hour')
      if(currentHourRow) {
        currentHourRow.scrollIntoView()
      }
    })

    onBeforeUnmount(()=>{
      if(wh) wh();
    })

    return {
      isEditor: auth.isEditor,
      date,
      loading,
      eventDialog,
      selectedEvent,
      addBookingDialog,
      expanded,
      formatDateExtended : utils.formatDateExtended,
      formatDate : utils.formatDate,
      hours,
      userOptions : computed(()=>{
        return globals.users.value.map(i => {
          return { title : `${i.name} ${i.surname}`, fiscal_code : i.fiscal_code, value : i._id}
        })
      }),
      validUserSeats,
      validUserSeatsOptions : computed(()=>{
        return validUserSeats.value.map(us => {
          let title = us.seats_types.map(getSeatsTypeLabel).join(', ')
          if(us.product_id) {
            const pr =  globals.products.value.find(i => i._id === us.product_id)
            const prTitle = pr?.kit ? pr.kit.title.it + " - " + pr.title.it : pr?.title.it;
            title = prTitle + ` (${us.seats_types.map(getSeatsTypeLabel).join(', ')})`
          }
          return { title , data : us, value : us._id }
        })
      }),
      dateJs : computed({
        get():Date{
          return date.value.toJSDate()
        },
        set(val:Date) {
          const dt = DateTime.fromJSDate(val)
          if(dt && dt.isValid) {
            date.value = dt;
          }
        }
      }),
      isToday,
      isClosed : computed(()=>{
        if(holidays.value[date.value.toISODate()!] !== undefined) {
          return holidays.value[date.value.toISODate()!];
        }
        return false
      }),
      setToday() {
        date.value = DateTime.now();
      },
      prevDay() {
        date.value = date.value.plus({day:-1})
      },
      nextDay() {
        date.value = date.value.plus({day:1})
      },
      events,
      isCurrentHour(hour:CalendarHour):boolean {
        if(!isToday.value) return false;

        const now = DateTime.now()
        const ht = DateTime.fromFormat(hour.time, "HH:mm")
        const endHt = DateTime.fromFormat(hour.time, "HH:mm").plus({hour:1})
        return now > ht && now < endHt
      },
      certStatusColor(status:'none'|'valid'|'expiring'|'expired') {
        switch (status) {
          case "none":
            return "error"
          case "valid":
            return "success"
          case "expired":
            return "error"
          case "expiring":
            return "warning"
        }
      },
      removeBooking(evt:BookingEvent) {
        const dt = utils.toDateTime(evt.item.date)
        let date = dt.toFormat("EEEE dd/MM/yyyy 'alle' HH:mm")
        messages.requestConfirm("Richiesta conferma", `Sei sicuro di voler eliminare la prenotazione di <strong>${evt.title}</strong> per <strong>${date}</strong>`, false, async ok => {
          if(!ok) return

          loading.value = true
          const res = await api.del('booking', evt._id)
          loading.value = true
          if(!res.success) {
            messages.error(res.message ?? Msg.serverError)
            return
          }
          messages.success("Prenotazione eliminata")
          await loadBookingData()
          eventDialog.value = false;
        })
      },
      form,
      rules,
      newItem,
      bookingDate,
      bookingDateFormat : computed(()=>{
        if(!bookingDate.value) return undefined
        const dt = DateTime.fromISO(bookingDate.value);
        if(!dt || ! dt.isValid) return undefined
        return dt.toFormat("EEEE dd MMMM yyyy")
      }),
      bookingHoursOptions : computed(()=>{
        return props.calendarHours.filter(item => {
          if(!bookingDate.value) return false
          const dt = DateTime.fromISO(bookingDate.value);
          return item.day === dt!.weekday;
        }).map((item) => {
          return { title: item.time, value : item._id }
        })
      }),
      openBookingDialog() {
        bookingDate.value = date.value.toISODate()!
        newItem.value = { calendar_hour_id: "", date: '', prefs_ids: [], type: props.seatsType, user_id: "", user_seat_id: ""}
        addBookingDialog.value = true
      },
      getSeatsTypeLabel,
      getSeatsTypeColor(st:SeatsType) {
        const opt = seatsTypesOptions.find(i => i.value === st)
        return opt?.color ?? ''
      },
      getProductName(id:string) {
        const p = globals.products.value.find(i => i._id === id)
        if(!p) return ''
        if(p.kit) {
          return p.kit.title.it + " - " + p.title.it
        }
        return p.title.it
      },
      async addBooking() {
        const { valid } = await form.value!.validate()
        if(!valid) return;
        newItem.value.type = props.seatsType
        loading.value = true;
        const res = await api.post<Booking>('booking', newItem.value)
        loading.value = false;
        if(!res.success) {
          messages.error(res.message ?? Msg.serverError)
          return
        }
        messages.success("Prenotazione inserita!")
        await loadBookingData()
        addBookingDialog.value = false
      },
      updateBookingDate() {
        let h = '12:00'
        if(newItem.value.calendar_hour_id) {
          let calH = props.calendarHours.find(i => i._id === newItem.value.calendar_hour_id)
          if(calH) h = calH.time
        }
        let parsed = DateTime.fromFormat(`${bookingDate.value} ${h}`, 'yyyy-MM-dd HH:mm');
        newItem.value.date = parsed.isValid ? parsed.toISO()! : '';
      },
      currentPrefs : computed(()=>{
        return globals.bookingprefs.value.filter(i => i.seats_type === props.seatsType)
      })
    }
  }
})
</script>


<style scoped>
.booking-calendar{
  position: relative;
}

</style>